import { generateClient } from '@maui/api-helpers'
import { auth, collections } from './endpoints'
import { createJSONResponseHandler } from '@/utils/createJSONResponseHandler'

const name = 'VTApi'

export const VTApi = generateClient({
  auth,
  collections,
}, {
  name,
  defaultHeaders: {
    accept: 'application/json',
  },
  onResponse: createJSONResponseHandler(name),
})
